export enum OverlayPages {
  DOCUMENTATION = 'documentation',
  HOME = 'home',
  LIBRARY = 'library',
  NEW = 'new',
  OPEN = 'open',
  ABOUT = 'about'
}
